import request from "../../utils/axios";

export const apiCreateCallRecord = async (data) => {
  const res = await request.post({ url: "/member/call-record/create", data });
  return res;
};

